import React, { useState } from 'react';
import {
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormLabel,
    Grid,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createCustomer } from '../../../services/store';
import { useSnackbar } from 'notistack';
import { useStyles } from '../../CreateOrder/CreateOrder.styles';
import { countries } from '../../../constants.js/countries.js';

export const AddClientModal = ({ storeId, userStoreId, isModalOpen, setIsModalOpen }) => {
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();

    const [code, setCode] = useState('57');

    const fieldsSchema = yup.object({
        name: yup.string().required('Se requiere el nombre'),
        code: yup.string(),
        phone: yup.string().required('Se requiere el teléfono'),
        email: yup.string().required('Se requiere el correo electrónico'),
        typeDocument: yup.string(),
        document: yup.string().required('Se requiere el documento'),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: '',
            code: '57',
            phone: '',
            email: '',
            typeDocument: 'CC',
            document: '',
        },
        resolver: yupResolver(fieldsSchema),
    });

    const onSubmit = (data) => {
        const payload = {
            first_name: data?.name,
            phone_number: `${data?.code}${data?.phone}`,
            document_type: data?.typeDocument,
            dni: data?.document,
            email: data?.email,
            user_store_id: userStoreId,
        };

        createCustomer(storeId, payload)
            .then(() => {
                enqueueSnackbar('Se a creado exitosamente del cliente', { variant: 'success' });
                setIsModalOpen(false);
            })
            .catch((err) => {});
    };

    const handleCodeChange = (newValue) => {
        setCode(newValue);
    };

    const countryToFlag = (isoCode) => {
        return typeof String.fromCodePoint !== 'undefined'
            ? isoCode
                  .toUpperCase()
                  .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
            : isoCode;
    };

    return (
        <Dialog open={isModalOpen} onClose={() => setIsModalOpen(!isModalOpen)}>
            <DialogTitle>
                <Typography className={classes.title}>Datos del cliente</Typography>
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent dividers>
                    <Card
                        elevation={0}
                        className={classes.cardList}
                        style={{
                            borderRadius: 0,
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }}
                    >
                        <FormControl variant="outlined" margin="normal" fullWidth>
                            <FormLabel htmlFor="name" className={classes.labels}>
                                Nombre y Apellido
                            </FormLabel>
                            <OutlinedInput
                                {...register('name')}
                                defaultValue={
                                    JSON.parse(sessionStorage.getItem('infoClient'))?.name
                                }
                                type="text"
                                id="name"
                                fullWidth
                            />
                        </FormControl>
                        {errors?.name && (
                            <Typography variant="body1" style={{ color: '#F80000', fontSize: 12 }}>
                                {errors?.name?.message}
                            </Typography>
                        )}

                        <FormControl variant="outlined" margin="normal" fullWidth>
                            <FormLabel htmlFor="customerWhatsapp" className={classes.labels}>
                                Número de WhatsApp
                            </FormLabel>
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                }}
                            >
                                <div className={classes.numberFieldCode}>
                                    <Autocomplete
                                        style={{ width: '100%' }}
                                        options={countries}
                                        noOptionsText="No hay resultados"
                                        value={code || ''}
                                        onChange={(event, value) => handleCodeChange(value.phone)}
                                        getOptionLabel={(option) => option.phone || code}
                                        renderOption={(option) => (
                                            <Typography>
                                                <span>{countryToFlag(option.code)}</span>
                                                {`${option.label} +${option.phone}`}
                                            </Typography>
                                        )}
                                        renderInput={(params) => (
                                            <FormControl>
                                                <TextField
                                                    {...params}
                                                    {...register('code')}
                                                    defaultValue={
                                                        JSON.parse(
                                                            sessionStorage.getItem('infoClient')
                                                        )?.code
                                                    }
                                                    variant="outlined"
                                                    placeholder="(+00)"
                                                    fullWidth
                                                />
                                            </FormControl>
                                        )}
                                    />
                                </div>
                                <FormControl className={classes.numberFieldWhatsapp}>
                                    <TextField
                                        {...register('phone')}
                                        defaultValue={
                                            JSON.parse(sessionStorage.getItem('infoClient'))?.phone
                                        }
                                        variant="outlined"
                                        placeholder="Ingresa tu número de WhatsApp"
                                        type="number"
                                        fullWidth
                                    />
                                </FormControl>
                            </div>
                        </FormControl>
                        {errors?.phone && (
                            <Typography variant="body1" style={{ color: '#F80000', fontSize: 12 }}>
                                {errors?.phone?.message}
                            </Typography>
                        )}

                        <FormControl variant="outlined" margin="normal" fullWidth>
                            <FormLabel htmlFor="email" className={classes.labels}>
                                Correo electrónico
                            </FormLabel>
                            <OutlinedInput
                                {...register('email')}
                                type="email"
                                defaultValue={
                                    JSON.parse(sessionStorage.getItem('infoClient'))?.email
                                }
                                id="email"
                                fullWidth
                            />
                        </FormControl>
                        {errors?.email && (
                            <Typography variant="body1" style={{ color: '#F80000', fontSize: 12 }}>
                                {errors?.email?.message}
                            </Typography>
                        )}

                        <Grid
                            container
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                            <Grid item xs={2}>
                                <FormControl variant="outlined" margin="normal" fullWidth>
                                    <FormLabel htmlFor="typeDocument" className={classes.labels}>
                                        Documento
                                    </FormLabel>
                                    <Select
                                        {...register('typeDocument')}
                                        defaultValue={
                                            JSON.parse(sessionStorage.getItem('infoClient'))
                                                ?.typeDocument
                                        }
                                        id="typeDocument"
                                    >
                                        <MenuItem value="CC">CC</MenuItem>
                                        <MenuItem value="TI">TI</MenuItem>
                                        <MenuItem value="Pasaporte">Pasaporte</MenuItem>
                                    </Select>
                                </FormControl>
                                {errors?.typeDocument && (
                                    <Typography
                                        variant="body1"
                                        style={{ color: '#F80000', fontSize: 12 }}
                                    >
                                        {errors?.typeDocument?.message}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={9}>
                                <FormControl variant="outlined" margin="normal" fullWidth>
                                    <FormLabel htmlFor="document" className={classes.labels}>
                                        Número de identificación
                                    </FormLabel>
                                    <OutlinedInput
                                        {...register('document')}
                                        defaultValue={
                                            JSON.parse(sessionStorage.getItem('infoClient'))
                                                ?.document
                                        }
                                        id="document"
                                        fullWidth
                                    />
                                </FormControl>
                                {errors?.document && (
                                    <Typography
                                        variant="body1"
                                        style={{ color: '#F80000', fontSize: 12 }}
                                    >
                                        {errors?.document?.message}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Card>
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={() => setIsModalOpen(false)} variant="contained">
                        Cancelar
                    </Button>
                    <Button type="submit" autoFocus color="primary" variant="contained">
                        Guardar cambios
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
